/**
 * https://www.pdftron.com/api/web/Core.AnnotationManager.html#showAnnotations__anchor
 */
export default annotations => window.documentViewer.getAnnotationManager().showAnnotations(annotations);
